import { createContext, useContext } from 'react';

type HistoryOutcomeCardContextProps = {
  outcomeId?: number;
  initialOdds?: number;
  odds?: number;
};

export const HistoryOutcomeCardContext = createContext<HistoryOutcomeCardContextProps>({});

export const useHistoryOutcomeCardContext = () => useContext(HistoryOutcomeCardContext);
